import * as React from "react"
import "./style_4.scss"

export default function ProductContentStyle4({ items }) {

    const displayHyphen = (data) => data.organisation_info && data.certificate_number && ' - '

    return (items?.map((data, index) => !!Object.keys(data)?.length && (
        <div key={index}
            className="product-content style_4"
        >
            <div className={`content-block-image`}>
                {data?.icon && <img src={data.icon} alt="" />}
            </div>

            <div className={`content-block-info`}>
                <h3>{data.title}</h3>
                {!!data.organisation_info
                    ? <div className='description'>{data.organisation_info}{displayHyphen(data)}{data.certificate_number}</div>
                    : <div className='description'>{data.certificate_number}</div>
                }
            </div>
        </div>
    ))
    )
}
